import {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import {axiosLogout} from '../../../../setup/axios/AxiosAuth'
import {axiosUserDelete} from '../../../../setup/axios/AxiosUser'
import {LoaderForm} from '../../forms/billing-form/components/BillingLoaderForm'

type Props = {
  modalShow: boolean
  setModalShow: any
}

const UserDeleteModal: FC<Props> = ({modalShow, setModalShow}) => {
  const intl = useIntl()
  const navigate = useNavigate()

  const [errorMessage, setErrorMessage] = useState('')
  const [loader, setLoader] = useState(false)

  const modalDeleteFunc = () => {
    setLoader(true)
    axiosUserDelete().then((resp) => {
      setLoader(false)
      if (resp.code === 200 && resp.message === 'Пользователь удален') {
        axiosLogout()
        navigate('/auth')
        setModalShow(false)
      }
      if (resp.code !== 200) {
        setErrorMessage('error')
      }
    })
  }

  return (
    <div>
      <Modal
        show={modalShow}
        onHide={() => {
          setModalShow(false)
        }}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Body style={{padding: '0'}}>
          {!loader && (
            <div className='d-flex flex-column h-150px justify-content-center'>
              <div className='authorization_title'>
                {intl.formatMessage({id: 'PROFILE.ACCOUNT-DELETE'})}
              </div>
              <div className='authorization_description text-start mt-5'>
                {intl.formatMessage({id: 'PROFILE.ACCOUNT-DELETE.MODAL'})}
              </div>
              {errorMessage === 'error' && (
                <div>{intl.formatMessage({id: 'LOGIN.ERROR.SOMETHING-WENT-WRONG'})}</div>
              )}

              <div className='d-flex flex-row'>
                <button
                  className='h-40px w-50 justify-content-center btn d-flex align-items-center mt-5 me-2'
                  style={{
                    borderRadius: '14px',
                    background: '#127FEE',
                    color: 'white',
                    backgroundColor: 'rgb(18,127,238)',
                  }}
                  onClick={() => modalDeleteFunc()}
                >
                  {intl.formatMessage({id: 'ABONEMENT.DELETE.YES'})}
                </button>
                <button
                  className='h-40px w-50 justify-content-center btn d-flex align-items-center mt-5 ms-2'
                  style={{
                    borderRadius: '14px',
                    background: '#127FEE',
                    color: 'white',
                    backgroundColor: '#9DCAF8',
                  }}
                  onClick={() => setModalShow(false)}
                >
                  {intl.formatMessage({id: 'BTNS.CANCEL'})}
                </button>
              </div>
            </div>
          )}
          {loader && (
            <div className='d-flex flex-column h-150px'>
              <LoaderForm />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export {UserDeleteModal}
